module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "cy"
    }
  }, [_c('p', {
    staticClass: "cipf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "piv"
    }
  }), _vm._v("Catholic Practice in North America | Angela Alaimo O’Donnell and John C. Seitz, series editors")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Copyright © 2015 Michael N. McGregor")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, or any other—except for brief quotations in printed reviews, without the prior permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("All quotations from Robert Lax’s poetry and other writings are used by permission of the Robert Lax Literary Trust.")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Excerpts from "), _c('i', [_vm._v("Seven Storey Mountain")]), _vm._v(" by Thomas Merton. Copyright 1948 by Houghton Mifflin Harcourt Publishing Company; copyright © renewed 1976 by the Trustees of The Merton Legacy Trust. Reprinted by permission of Houghton Mifflin Harcourt Publishing Company. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Quotations from Thomas Merton letters first published in "), _c('i', [_vm._v("When Prophecy Still Had a Voice")]), _vm._v(" are reprinted by permission of the Merton Legacy Trust.")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Fordham University Press has no responsibility for the persistence or accuracy of URLs for external or third-party Internet websites referred to in this publication and does not guarantee that any content on such websites is, or will remain, accurate or appropriate.")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Fordham University Press also publishes its books in a variety of electronic formats. Some content that appears in print may not be available in electronic books.")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Visit us online at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.fordhampress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.fordhampress.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("McGregor, Michael N."), _c('br'), _vm._v("\n      Pure act : the uncommon life of Robert Lax / Michael N. McGregor. — First edition."), _c('br'), _vm._v("\n           pages cm. — (Catholic practice in North America)"), _c('br'), _vm._v("\n        Includes bibliographical references and index."), _c('br'), _vm._v("\n      ISBN 978-0-8232-6801-6 (hardback)"), _c('br'), _vm._v("\n     1.  Lax, Robert. 2.  Poets, American—20th century—Biography. 3.  Poetry—Authorship.  I. Title."), _c('br'), _vm._v("\n      PS3523.A972Z76 2015"), _c('br'), _vm._v("\n      811'.54—dc23"), _c('br'), _vm._v("\n      [B]"), _c('br'), _vm._v("\n                                                                2015009511    "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("First edition")]), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pv"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eaa8f74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/McGregor0003.vue
// module id = 63
// module chunks = 0